import React, { useState } from 'react';
import { BellRing, MonitorSmartphone, Send, Loader2 } from 'lucide-react';
import { useT } from '../../services/i18n';
import { browserNotif, centreTarget } from '../../services/browserNotif';

// Partner space: enable Web Push on this device (linked to the centre's manage token) + real test push
const CentrePushCard = ({ token }) => {
  const { t } = useT();
  const target = centreTarget(token);
  const [perm, setPerm] = useState(browserNotif.permission());
  const [on, setOn] = useState(browserNotif.enabled(target));
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState('');

  const enable = async () => { setBusy(true); const p = await browserNotif.enable(target); setPerm(p); setOn(browserNotif.enabled(target)); setBusy(false); };
  const disable = async () => { setBusy(true); await browserNotif.disable(target); setOn(false); setBusy(false); };
  const test = async () => {
    setBusy(true); setResult('');
    try { const r = await browserNotif.test(target); setResult(r.devices ? t('nc.pushTestResult', { sent: r.sent, devices: r.devices }) : t('nc.pushTestNone')); } catch { setResult(t('ps.sendFailed')); } finally { setBusy(false); }
  };

  return (
    <section className="bg-white rounded-xl shadow-sm p-6 mb-6" data-testid="centre-push-card">
      <h2 className="text-base md:text-lg font-bold text-gray-900 flex items-center gap-2 mb-1"><MonitorSmartphone size={18} className="text-orange-500" /> {t('nc.pushTitle')}</h2>
      <p className="text-xs text-gray-500 mb-3">{t('ps.pushIntro')}</p>
      {perm === 'denied' && <p className="text-xs text-red-600 mb-2" data-testid="cs-push-denied">{t('nc.pushDenied')}</p>}
      {perm === 'unsupported' && <p className="text-xs text-gray-500 mb-2" data-testid="cs-push-unsupported">{t('nc.pushUnsupported')}</p>}
      <div className="flex flex-wrap items-center gap-2">
        {on
          ? <button type="button" onClick={disable} disabled={busy} className="inline-flex items-center gap-1 rounded-full border border-emerald-300 bg-emerald-50 px-3 py-1.5 text-xs font-medium text-emerald-800" data-testid="cs-push-disable"><BellRing size={13} /> {browserNotif.pushActive(target) ? t('nc.pushEnabledBg') : t('nc.pushEnabled')} · {t('nc.pushDisable')}</button>
          : <button type="button" onClick={enable} disabled={busy || perm === 'denied' || perm === 'unsupported'} className="inline-flex items-center gap-1 rounded-full bg-gray-900 px-3 py-1.5 text-xs font-medium text-white hover:bg-gray-800 disabled:opacity-40" data-testid="cs-push-enable"><BellRing size={13} /> {t('nc.pushEnable')}</button>}
        <button type="button" onClick={test} disabled={busy} className="inline-flex items-center gap-1 rounded-full border border-gray-300 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-40" data-testid="cs-push-test">{busy ? <Loader2 size={13} className="animate-spin" /> : <Send size={13} />} {t('nc.pushTest')}</button>
        {result && <span className="text-xs text-gray-600" data-testid="cs-push-test-result">{result}</span>}
      </div>
    </section>
  );
};

export default CentrePushCard;
